import { format } from 'date-fns'
import * as React from 'react'
import { z } from 'zod'
import { DatePickerPopover } from '~/elements'
import { Input, Button } from '@bpinternal/ui-kit-next'
import { Calendar } from 'lucide-react'
import { cn } from '~/utils'

type DateInputProps = {
  value: Date
  onChange: (date: Date) => void
  onValidChanged?: (valid: boolean) => void
  fromDate?: Date
}

const dateSchema = z.coerce.date()

export const DateInput = ({ value, onChange, onValidChanged }: DateInputProps) => {
  const [valid, setValid] = React.useState(true)

  const [inputValue, setInputValue] = React.useState<string>(format(value, 'y-LL-dd HH:mm:ss'))

  const setValidAndNotify = (valid: boolean) => {
    setValid(valid)
    if (onValidChanged) {
      onValidChanged(valid)
    }
  }

  return (
    <div className="relative flex items-center">
      <Input
        onBlur={() => {
          if (valid) {
            onChange(dateSchema.parse(inputValue))
            setInputValue(format(value, 'y-LL-dd HH:mm:ss'))
          }
        }}
        onChange={(e) => {
          const value = e.target.value.trim()
          if (!value) {
            setInputValue('')
            setValidAndNotify(false)
          } else {
            const result = dateSchema.safeParse(value)
            setValidAndNotify(result.success)
            setInputValue(value)
          }
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            if (valid) {
              onChange(dateSchema.parse(inputValue))
            }
          }
        }}
        value={inputValue}
        className={cn('pr-5 shadow-none', {
          'border-red-400 bg-red-50 focus-visible:ring-red-400': !valid,
        })}
      />
      <DatePickerPopover
        date={value}
        onDateSelected={(d) => {
          onChange(d ?? value)
          setInputValue(format(d ?? value, 'y-LL-dd HH:mm:ss'))
        }}
      >
        <Button
          size="icon"
          variant="outline"
          className="absolute right-1 top-1 h-7 w-7 rounded border-none shadow-none"
        >
          <Calendar />
        </Button>
      </DatePickerPopover>
    </div>
  )
}
